import { colors } from '@factorialco/deprecated-design-system'
import domtoimage from 'dom-to-image'

import { download } from 'modules/core/lib/download'

export const takeSnapshot = (svgElement: HTMLElement) => {
  const bgColor = colors.grey000White

  return domtoimage.toJpeg(svgElement, { bgcolor: bgColor }).then(function (dataUrl: string) {
    download(dataUrl, 'orgchart.jpeg')
  })
}
